import { Component } from '@angular/core';

@Component({
  selector: 'app-suppliersidebar',
  templateUrl: './app-suppliersidebar.component.html'
})
export class AppSuppliersidebarComponent { }



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-suppliersidebar/app-suppliersidebar.component.ts